module.exports = __webpack_public_path__ + "img/icon_eng.0476309.png";